import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
export function userCanMessageNonMembers(userState) {
    return (requireAnySystemPermission(userState, 'list-all-accounts') ||
        (requireAnyOrgPermission(userState, 'manage-members') && requireAnyOrgPermission(userState, 'view-and-message-members')));
}
